import { render } from "./NoticesView.vue?vue&type=template&id=d9983106"
import script from "./NoticesView.vue?vue&type=script&lang=js"
export * from "./NoticesView.vue?vue&type=script&lang=js"

import "./NoticesView.vue?vue&type=style&index=0&id=d9983106&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__